/* 
    Bar chart Module
*/
import cloneDeep from 'lodash/cloneDeep';
import barChartConfigBuilder from './bar-chart-config-builder';
import { columnTooltip } from '../../widget-utilities/widget-tooltip';
import d3Utils from '../../../../utils/d3Utils';
import chartUtils from '../../../../utils/chart-utils';

var barChart = function barChart() {

    // Render bar chart widget
    var renderWidget = function renderWidget(widgetConfig) {
        var ContainerId = widgetConfig.ContainerId,
            Model = widgetConfig.Model,
            Width = widgetConfig.Width,
            Height = widgetConfig.Height,
            FontWidth = widgetConfig.FontWidth,
            FontHeight = widgetConfig.FontHeight,
            Cloud = widgetConfig.Cloud,
            StampText = widgetConfig.StampText,
            ColorScheme = widgetConfig.ColorScheme,
            SortData = widgetConfig.SortData,
            Data = widgetConfig.Data,
            ChartConfig = widgetConfig.ChartConfig;


        var parentContainerId = ContainerId.includes('flip-') ? ContainerId.split('flip-')[1] : ContainerId;

        var el = window.document.querySelector('#' + ContainerId);

        d3.select(el).select('svg').remove();

        var sortData = JSON.parse(chartUtils.replaceAll(JSON.stringify(SortData), '\x01', ""));
        var sortKeyName = ChartConfig.SortMatchPropertyName;
        var sortValueName = ChartConfig.SortValuePropertyName;
        var yAxisTickSpacing = 0.075;
        var xAxisTickSpacing = Number(ChartConfig.XAxisTickSpacing);
        var hPadding = 0.02;
        var vPadding = 0.02;
        var xAxisLabelSize = 0.02;
        var textOffset = ChartConfig.TextOffset;

        var margin = { top: 0.01, right: 0.02, bottom: 0.01, left: 0.02 },
            width = Number(chartUtils.replaceAll(Width, '\x01', "")),
            height = Number(chartUtils.replaceAll(Height, '\x01', "")),
            fontWidth = Number(FontWidth),
            fontHeight = Number(FontHeight);
        var defaultPerspective = ChartConfig.DefaultPerspective;

        var xFieldName = ChartConfig.XAxisField,
            yFieldName = ChartConfig.YAxisFields ? ChartConfig.YAxisFields[0] : '',
            CrumbFieldConfig = ChartConfig.CrumbFieldConfig,
            crumbFieldName = CrumbFieldConfig[Object.keys(CrumbFieldConfig)[0]],
            crumbDisplayFieldName = ChartConfig.CrumbDisplayFieldName,
            crumbFormat = {
            'CloudName': Cloud,
            'ModelName': Model,
            'Type': 'Node',
            'Name': Object.keys(CrumbFieldConfig)[0],
            'FieldName': crumbFieldName,
            'Value': null,
            'DisplayFieldName': crumbDisplayFieldName,
            'DisplayValue': null
        },
            xAxisText = ChartConfig.XAxisName,
            yAxisText = ChartConfig.YAxisNames[0],
            displayFormat = ChartConfig.ValueFormat,
            currencyPrefix = ChartConfig.CurrencySymbol,
            accumulationType = ChartConfig.AggregationType,
            rotationAngle = Number(ChartConfig.RotationAngle);
        var yAxisFormat = ChartConfig.YAxisFormat;
        var gridLines = Number(chartUtils.chartGridLine[ChartConfig.GridLines.toLowerCase()]);
        var showLegend = ChartConfig.ShowLegend;
        var hideXAxis = ChartConfig.HideYAxis;
        var hideYAxis = ChartConfig.HideXAxis;
        var xUpperLimit = Number(ChartConfig.XUpperLimitOverride);
        var xLowerLimit = Number(ChartConfig.XLowerLimitOverride);
        var count = 'Count';
        var classifierField = ChartConfig.ClassifierField;
        var sortByDate = ChartConfig.SortByDate;
        var tipField = !ChartConfig.TipField ? '' : ChartConfig.TipField;;
        var baseFormat = ChartConfig.BaseFormat;
        var stampText = StampText;
        var smartLabels = ChartConfig.smartLabels;
        var inverseSort = ChartConfig.InverseSort;
        var isDecimalPercentNumber = false;
        smartLabels = smartLabels == "true" ? true : false;
        var seriesConfig = JSON.parse(chartUtils.replaceAll(JSON.stringify(ChartConfig.Series), '\x001', ""));
        var seriesData = JSON.parse(chartUtils.replaceAll(JSON.stringify(Data.seriesData), '\x001', ""));
        var seriesAccumulators = {};
        var maxValue = 0;
        var minValue = 0;
        var maxLabelLength = 0;
        var baseYValues = [];
        var base = 'base';
        var negativeBase = 'negative-base';
        var isNegative = false;
        var barSeriesNames = [];

        var legendRectSize = 0.04;
        var legendVerticalPad = 0.02;
        var legendSpacing = 0.004;
        var legendWidth = 0.1;
        var offset = 0.005;

        var tickCount = Number(ChartConfig.TickCount);
        var displayCount = Number(ChartConfig.DisplayCount);
        var legendLineCount = Number(ChartConfig.LegendLineCount);
        var legendLocation = ChartConfig.LegendLocation;
        var sortAxis = ChartConfig.SortAxis;
        var defaultRange = ChartConfig.DefaultRange;
        var colorScheme = JSON.parse(chartUtils.replaceAll(JSON.stringify(ColorScheme), '\x01', ""));
        var colorPalette = JSON.parse(chartUtils.replaceAll(JSON.stringify(ChartConfig.ColorPalette), '\x01', ""));
        var SecondaryAxisLabel = ChartConfig.SecondaryAxisLabel;
        var yAxisDateFormat = ChartConfig.CategoryDateFormat;
        var transitionEase = 'linear';

        if (seriesConfig !== null && seriesConfig.length > 0 && seriesConfig[0].ShowPercentage === true) {
            $("[id^=CurrencySymbol]").removeClass("dropdown-enabled").addClass("dropdown-disabled").prop("disabled", "disabled").val("--");

            $("[id^=ValueFormat]").removeClass("dropdown-enabled").addClass("dropdown-disabled").prop("disabled", "disabled").val(',.0f%');

            $("[id^=BaseFormat]").removeClass("dropdown-enabled").addClass("dropdown-disabled").prop("disabled", "disabled").val("None");
        }

        if (fontWidth == 0) fontWidth = 10;

        if (fontHeight == 0) fontHeight = 10;

        var yAxisLabelSize = fontHeight / (width - (margin.left + margin.right) * width);

        if (yAxisFormat == null || yAxisFormat.trim().length == 0 || yAxisFormat == chartUtils.defaultYAxisFormat) yAxisFormat = null;

        if (sortKeyName != null && sortKeyName.trim().length == 0) sortKeyName = null;

        if (sortValueName != null && sortValueName.trim().length == 0) sortValueName = null;

        if (inverseSort.toString().toLocaleLowerCase() != "true" && inverseSort.toString().toLocaleLowerCase() != "false") inverseSort = false;

        if (rotationAngle > 0) margin.bottom = 0.08;

        if (isNaN(textOffset)) textOffset = -0.01;else textOffset = Number(textOffset);

        if (yAxisTickSpacing > 1) yAxisTickSpacing = (yAxisTickSpacing / 100).toFixed(3);

        if (isNaN(xAxisTickSpacing) || xAxisTickSpacing == 0) xAxisTickSpacing = 0.05;

        if (xAxisTickSpacing > 1) xAxisTickSpacing = (xAxisTickSpacing / 100).toFixed(3);

        if (xAxisTickSpacing > 0.5) xAxisTickSpacing = 0.5;

        if (xAxisText == null || xAxisText.trim().length == 0) xAxisLabelSize = 0;

        if (yAxisText == null || yAxisText.trim().length == 0) {
            yAxisLabelSize = 0;
            hPadding = 0;
        }

        if (isNaN(displayCount)) displayCount = 0;

        if (isNaN(legendLineCount)) legendLineCount = 1;

        if (isNaN(tickCount) || tickCount == 0) tickCount = 10;

        if (!defaultRange) minValue = Number.POSITIVE_INFINITY;

        if (yAxisDateFormat == "") yAxisDateFormat = null;

        var accumulator = [];
        var count = 0;
        var processed = {};

        var y = d3.scale.ordinal();

        var y1 = d3.scale.ordinal();

        var x = d3.scale.linear();

        var sortAccumulator = {};

        if (sortData != null) {
            for (var i = 0; i < sortData.length; i++) {
                var d = sortData[i];

                if (d[sortKeyName] == null || d[sortValueName] == null) continue;

                if (sortAccumulator[d[sortKeyName]] == null) {
                    sortAccumulator[d[sortKeyName]] = Number(d[sortValueName]);

                    continue;
                }

                sortAccumulator[d[sortKeyName]] = sortAccumulator[d[sortKeyName]] + Number(d[sortValueName]);
            }
        }

        if (seriesConfig != null) {
            for (var index = 0; index < seriesConfig.length; index++) {
                var series = seriesConfig[index];

                if (series.SeriesType != chartUtils.chartSeriesType.bar) continue;

                var seriesItemData = null;

                if (seriesData[series.SeriesName] != undefined) seriesItemData = JSON.parse(seriesData[series.SeriesName]);

                var tempAccumulator = [];

                var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');

                if (seriesItemData != null) {
                    for (var i = 0; i < seriesItemData.length; i++) {
                        var item = seriesItemData[i];

                        if (item[yFieldName] == null || item[series.FieldName] == null) continue;

                        if (isNaN(parseInt(item[yFieldName])) && item[yFieldName].trim().length == 0) continue;

                        if (yAxisDateFormat != null) item[yFieldName] = chartUtils.formatDate(item[yFieldName], yAxisDateFormat);

                        var basevalue = chartUtils.findValue(baseYValues, yFieldName, item[yFieldName]);

                        if (basevalue == null) {
                            basevalue = {};
                            basevalue[yFieldName] = item[yFieldName];
                            basevalue[base] = 0;
                            basevalue[negativeBase] = 0;
                            basevalue[series.FieldName] = 0;
                            basevalue["ShowPercentage"] = series.ShowPercentage;

                            if (series.CrumbDisplayFieldName != null && series.CrumbDisplayFieldName.trim().length > 0) basevalue[series.CrumbDisplayFieldName] = item[series.CrumbDisplayFieldName];

                            baseYValues.push(basevalue);
                        }

                        value = {};

                        value[yFieldName] = item[yFieldName];

                        // value[series.FieldName]
                        // = Math.round(Number(item[series.FieldName]) * 100) / 100;
                        value[series.FieldName] = Number(item[series.FieldName]);

                        value[series.CrumbFieldName] = item[series.CrumbFieldName];

                        value[series.CrumbDisplayFieldName] = item[series.CrumbDisplayFieldName];

                        value[base] = 0;

                        value["ShowPercentage"] = series.ShowPercentage;

                        value["counter"] = item["RecordCount"];

                        if (tipField != null && tipField.trim().length > 0 && item[tipField] != null) value[tipField] = item[tipField];

                        if (series.SeriesType == chartUtils.chartSeriesType.bar) if (!chartUtils.inArray(barSeriesNames, series.SeriesName)) barSeriesNames.push(series.SeriesName);

                        if (series.Tooltip != null && series.Tooltip.TooltipConfigs != null && series.Tooltip.TooltipConfigs.length > 0) for (var tipIndex = 0; tipIndex < series.Tooltip.TooltipConfigs.length; tipIndex++) {
                            var tipItem = series.Tooltip.TooltipConfigs[tipIndex];

                            var tipValue = chartUtils.getTooltipValue(tipItem, item);

                            if (tipItem.TipField == series.FieldName && tipItem.AggregationType == "") tipValue = item[series.FieldName];

                            if (tipItem.TipField == series.crumbFieldName && tipItem.AggregationType == "") tipValue = item[series.crumbFieldName];

                            if (tipItem.TipField == series.CrumbDisplayFieldName && tipItem.AggregationType == "") tipValue = item[series.CrumbDisplayFieldName];

                            if (tipItem.TipField == yFieldName && tipItem.AggregationType == "") tipValue = item[yFieldName];

                            value[tipItem.Id] = tipValue;
                        }

                        accumulator.push(value);

                        tempAccumulator.push(value);

                        if (series.SeriesType == chartUtils.chartSeriesType.bar) basevalue[base] = value[series.FieldName];

                        basevalue[series.FieldName] = value[series.FieldName];
                        if (value[series.FieldName] < 0) basevalue[negativeBase] = value[series.FieldName];
                    }

                    var tempMaxValue = d3.max(tempAccumulator, function (d) {
                        return Number(d[series.FieldName]);
                    });

                    tempMaxValue = isNaN(tempMaxValue) ? 0 : tempMaxValue;

                    maxValue = Math.max(maxValue, tempMaxValue);

                    var tempMinValue = d3.min(tempAccumulator, function (d) {
                        return Number(d[series.FieldName]);
                    });

                    tempMinValue = isNaN(tempMinValue) ? 0 : tempMinValue;

                    minValue = Math.min(minValue, tempMinValue);

                    seriesAccumulators[seriesName] = tempAccumulator;
                }

                if (series.SubSeries != null && series.SubSeries.length > 0) {
                    var baseSeries = series;

                    for (var index1 = 0; index1 < baseSeries.SubSeries.length; index1++) {

                        series = baseSeries.SubSeries[index1];

                        if (seriesData[series.SeriesName] == null || seriesData[series.SeriesName] == null) continue;

                        var seriesItemData = JSON.parse(seriesData[series.SeriesName]);

                        var tempAccumulator = [];

                        var baseSeriesAccumulator = seriesAccumulators[baseSeries.SeriesName];

                        if (baseSeriesAccumulator == null) {
                            baseSeriesAccumulator = [];
                            seriesAccumulators[baseSeries.SeriesName] = baseSeriesAccumulator;

                            if (!chartUtils.inArray(barSeriesNames, baseSeries.SeriesName)) barSeriesNames.push(baseSeries.SeriesName);
                        }

                        var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');

                        for (var i = 0; i < seriesItemData.length; i++) {
                            var item = seriesItemData[i];

                            if (item[yFieldName] == null || item[series.FieldName] == null) continue;

                            if (item[yFieldName].toString().trim().length == 0) continue;

                            if (yAxisDateFormat != null) item[yFieldName] = chartUtils.formatDate(item[yFieldName], yAxisDateFormat);

                            var basevalue = chartUtils.findValue(baseYValues, yFieldName, item[yFieldName]);

                            if (basevalue == null) {
                                basevalue = {};
                                basevalue[yFieldName] = item[yFieldName];
                                basevalue[base] = 0;
                                basevalue[negativeBase] = 0;
                                basevalue[series.FieldName] = 0;
                                basevalue["ShowPercentage"] = series.ShowPercentage;

                                if (series.CrumbDisplayFieldName != null && series.CrumbDisplayFieldName.trim().length > 0) basevalue[series.CrumbDisplayFieldName] = item[series.CrumbDisplayFieldName];

                                baseYValues.push(basevalue);

                                //Add it to the base accumulator
                                var baseSeriesValue = {};
                                baseSeriesValue[yFieldName] = item[yFieldName];
                                baseSeriesValue[series.FieldName] = 0;
                                baseSeriesValue[base] = 0;
                                baseSeriesAccumulator.push(baseSeriesValue);
                            }

                            value = {};

                            value[yFieldName] = item[yFieldName];

                            // value[series.FieldName]
                            // = Math.round(Number(item[series.FieldName]) * 100) / 100;
                            value[series.FieldName] = Number(item[series.FieldName]);

                            value[base] = basevalue[base];

                            value["ShowPercentage"] = series.ShowPercentage;

                            value["counter"] = item["RecordCount"];

                            if (tipField != null && tipField.trim().length > 0 && item[tipField] != null) value[tipField] = item[tipField];

                            if (classifierField != null && item[classifierField] != null) value["className"] = chartUtils.makeStyleName(item[classifierField]);

                            if (series.Tooltip != null && series.Tooltip.TooltipConfigs != null && series.Tooltip.TooltipConfigs.length > 0) for (var tipIndex = 0; tipIndex < series.Tooltip.TooltipConfigs.length; tipIndex++) {
                                var tipItem = series.Tooltip.TooltipConfigs[tipIndex];

                                var tipValue = chartUtils.getTooltipValue(tipItem, item);

                                if (tipItem.TipField == series.FieldName && tipItem.AggregationType == "") tipValue = value[series.FieldName];

                                if (tipItem.TipField == series.crumbFieldName && tipItem.AggregationType == "") tipValue = item[series.crumbFieldName];

                                if (tipItem.TipField == series.CrumbDisplayFieldName && tipItem.AggregationType == "") tipValue = item[series.CrumbDisplayFieldName];

                                if (tipItem.TipField == yFieldName && tipItem.AggregationType == "") tipValue = item[yFieldName];

                                value[tipItem.Id] = tipValue;
                            }

                            value[negativeBase] = basevalue[negativeBase];
                            tempAccumulator.push(value);

                            basevalue[base] = value[base] + value[series.FieldName];
                            if (value[series.FieldName] < 0) basevalue[negativeBase] = value[negativeBase] + value[series.FieldName];
                        }

                        var tempMaxValue = d3.max(tempAccumulator, function (d) {
                            return Number(d[series.FieldName]) + Number(d[base]);
                        });

                        maxValue = Math.max(maxValue, tempMaxValue);

                        var tempMinValue = d3.min(tempAccumulator, function (d) {
                            return Number(d[series.FieldName]) + Number(d[base]);
                        });

                        minValue = Math.min(minValue, tempMinValue);

                        seriesAccumulators[seriesName] = tempAccumulator;
                    }
                }
            }

            sort(baseYValues);

            if (seriesConfig.StackOnField == null) {
                seriesConfig.ShowPercentage = false;
            }

            var baseYValuesLength = baseYValues.length;

            var percentRatioYFieldMapping = {};
            for (var currBaseYValue = 0; currBaseYValue < baseYValuesLength; currBaseYValue++) {
                var baseYValue = baseYValues[currBaseYValue];
                if (baseYValue.ShowPercentage) {
                    if (baseYValue.hasOwnProperty('base')) {
                        if (parseFloat(baseYValue['base']) >= 0) {
                            percentRatioYFieldMapping[baseYValue[yFieldName]] = parseFloat(baseYValue['base']) / 100;
                            baseYValue['base'] = 100;
                        }
                    }
                }
            }

            for (var _iterator = Object.entries(seriesAccumulators), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref2;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref2 = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref2 = _i.value;
                }

                var _ref = _ref2;
                var key = _ref[0];
                var _value = _ref[1];

                var seriesAccumulatorsKeyLength = seriesAccumulators[key].length;
                for (var accIndex = 0; accIndex < seriesAccumulatorsKeyLength; accIndex++) {

                    var currSeriesindex = seriesAccumulators[key][accIndex];

                    var ratio = percentRatioYFieldMapping[currSeriesindex[yFieldName]];
                    if (currSeriesindex.ShowPercentage) {
                        if (currSeriesindex.hasOwnProperty('base') && parseFloat(currSeriesindex['base']) > 0) currSeriesindex['base'] = parseFloat(currSeriesindex['base']) / ratio;

                        if (currSeriesindex.hasOwnProperty(series.FieldName) && parseFloat(currSeriesindex[series.FieldName]) > 0) currSeriesindex[series.FieldName] = parseFloat(currSeriesindex[series.FieldName]) / ratio;
                    }
                }
            }

            if (displayCount > 0) {
                baseYValues = chartUtils.getBottomX(displayCount, baseYValues);
                var tempMaxValue = d3.max(baseYValues, function (d) {
                    return Number(d[base]);
                });

                maxValue = Math.max(maxValue, tempMaxValue);
                for (var index = 0; index < baseYValues.length; index++) {
                    if (baseYValues[index]['negative-base'] < 0) {
                        isNegative = true;
                        break;
                    }
                }
            }

            if (baseSeries) {
                for (var currentSeries = 0; currentSeries < baseSeries["SubSeries"].length; currentSeries++) {
                    var series = baseSeries["SubSeries"][currentSeries];
                    var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');
                    var currentSeriesAccumulator = seriesAccumulators[seriesName];
                    if (currentSeriesAccumulator == null || currentSeriesAccumulator == 'undefined') continue;
                    //if length of series accumulators is less than base series - add zeros for missing values
                    if (currentSeriesAccumulator.length < baseYValues.length) {
                        for (var index = 0; index < baseYValues.length; index++) {
                            if (chartUtils.findValue(currentSeriesAccumulator, yFieldName, baseYValues[index][yFieldName]) == null) {
                                var value = {};
                                value[yFieldName] = baseYValues[index][yFieldName];
                                value[series.FieldName] = 0;
                                value[series.CrumbFieldName] = null;
                                value[series.CrumbDisplayFieldName] = null;
                                value[base] = 0;
                                currentSeriesAccumulator.push(value);
                            }
                        }
                    }
                }
            }

            for (var currentSeries = 0; currentSeries < Object.keys(seriesAccumulators).length; currentSeries++) {
                var series = Object.keys(seriesAccumulators)[currentSeries];

                chartUtils.sortByBaseSeries(baseYValues, seriesAccumulators[series], yFieldName);
            }

            // Category axis label with maximum length
            var maxLabel = null;

            //Y Axis domain
            y.domain(baseYValues.map(function (d) {
                if (maxLabelLength < d[yFieldName].toString().length) {
                    maxLabel = d[yFieldName];
                    maxLabelLength = maxLabel.toString().length;
                }
                return d[yFieldName];
            }));

            var charCounter = 0;

            if (maxLabel != null) for (var i = 0; i < maxLabel.length; i++) {
                if (maxLabel[i] == "I" || maxLabel[i] == "i" || maxLabel[i] == "l" || maxLabel[i] == " ") charCounter++;
            }

            maxLabelLength -= Math.round(charCounter / 3);

            y1.domain(barSeriesNames);
        }

        if (maxLabelLength == 0) maxLabelLength = 50;

        if (yAxisText == null || yAxisText.length == 0) yAxisLabelSize = 0;

        //Compute X Axis Tick Spacing.
        xAxisTickSpacing = fontHeight / height + vPadding;

        //Assigned 1% size to each number in value label
        var maxLabelSize = chartUtils.format(maxValue, displayFormat, currencyPrefix, maxValue, baseFormat, isDecimalPercentNumber).length;

        maxLabelSize = isNaN(maxLabelSize) ? 0 : maxLabelSize * 0.01;

        var legendX = showLegend ? margin.left : 0;
        var legendY = showLegend ? margin.top : 0;
        var chartX = Number(margin.left) + Number(yAxisLabelSize) + Number(hPadding) + Number(yAxisTickSpacing);
        legendX = chartX;

        var chartY = !showLegend ? margin.top : margin.top + legendRectSize * legendLineCount + legendVerticalPad + legendSpacing * (legendLineCount - 1);

        var chartWidth = 1 - chartX - margin.right - textOffset;

        var chartHeight = 1 - (margin.bottom + Number(xAxisLabelSize) + vPadding + Number(xAxisTickSpacing)) - chartY;
        var labelX = margin.left;

        for (var index = 0; index < seriesConfig.length; index++) {
            var series = seriesConfig[index];
            if (series.ShowLabels && series.LabelPosition == chartUtils.labelPosition.outside) {
                chartWidth -= maxLabelSize;
                break;
            }
        }

        if (showLegend) {
            switch (legendLocation) {
                case chartUtils.legendLocation.bottom:
                    {
                        chartY = margin.top;
                        chartHeight = 1 - (margin.bottom + Number(xAxisLabelSize) + Number(vPadding) + Number(xAxisTickSpacing) + Number(legendVerticalPad) + Number(legendRectSize)) - chartY;
                        legendY = chartHeight + Number(xAxisTickSpacing) + Number(legendVerticalPad) + Number(legendRectSize);
                        break;
                    }
                case chartUtils.legendLocation.right:
                    {
                        chartWidth = 1 - chartX - margin.right - Number(legendWidth) - Number(hPadding);
                        legendX = chartWidth + chartX + Number(hPadding);
                        chartY = margin.top;
                        chartHeight = 1 - (margin.bottom + Number(xAxisLabelSize) + Number(vPadding) + Number(xAxisTickSpacing)) - chartY;
                        break;
                    }
                case chartUtils.legendLocation.left:
                    {
                        chartWidth = 1 - chartX - margin.right - Number(legendWidth);
                        chartX += Number(legendWidth);
                        legendX = margin.left;
                        labelX += Number(legendWidth) + Number(hPadding);
                        chartY = margin.top;
                        chartHeight = 1 - (margin.bottom + Number(xAxisLabelSize) + Number(vPadding) + Number(xAxisTickSpacing)) - chartY;
                        break;
                    }
            }
        }

        var xAxisLabelY = Number(chartHeight) - Number(vPadding);

        chartX = chartUtils.makeRelative(chartX, width);
        chartY = chartUtils.makeRelative(chartY, height);
        chartWidth = chartUtils.makeRelative(chartWidth, width);
        chartHeight = chartUtils.makeRelative(chartHeight, height);
        xAxisLabelY = chartUtils.makeRelative(xAxisLabelY, height);
        labelX = chartUtils.makeRelative(labelX, width);
        textOffset = chartUtils.makeRelative(textOffset, width);
        legendRectSize = chartUtils.makeRelative(legendRectSize, Math.min(width, height));
        legendSpacing = chartUtils.makeRelative(legendSpacing, width);
        legendVerticalPad = chartUtils.makeRelative(legendVerticalPad, height);
        legendX = chartUtils.makeRelative(legendX, width);
        legendY = chartUtils.makeRelative(legendY, height);
        offset = chartUtils.makeRelative(offset, height);

        var svg = d3.select(el).append('svg:svg').attr('class', 'chart maximize-trigger').attr('width', width).attr('height', height).attr('yAxisTickSpace', yAxisTickSpacing).attr('viewBox', '0 0 ' + width + ' ' + height).attr('preserveAspectRatio', 'xMidYMid');

        var chartContainer = svg.append('g');

        var color = d3.scale.category10();
        var color2 = d3.scale.category20b();
        var seriesColor = d3.scale.category20();

        if (colorPalette != null && colorPalette.length > 0) seriesColor = d3.scale.ordinal().range(colorPalette);else if (colorScheme != null && colorScheme.length > 0) seriesColor = d3.scale.ordinal().range(colorScheme);

        if (seriesConfig.StackOnField != null) defaultRange = true;

        if (!defaultRange) minValue = minValue < 0 ? minValue : minValue - minValue / 10;

        var upperLimit = 100; //Setting upper limit for Normalized data
        var lowerLimit = minValue;

        var seriesConfigLength = seriesConfig.length;

        for (var idx = 0; idx < seriesConfigLength; idx++) {
            if (!seriesConfig[idx].ShowPercentage) {
                upperLimit = maxValue;
                break;
            }
        }

        if (!isNaN(xUpperLimit) && xUpperLimit > maxValue) upperLimit = xUpperLimit;

        //if(!isNaN(xLowerLimit))
        //  lowerLimit = xLowerLimit;

        //Define axes range and domain
        y.rangeBands([chartHeight, 0], .3);
        y1.rangeRoundBands([0, y.rangeBand()]);
        if (displayCount > 0 && !isNegative) x.rangeRound([0, chartWidth]).domain([0, upperLimit]).nice(tickCount);else x.rangeRound([0, chartWidth]).domain([lowerLimit, upperLimit]).nice(tickCount);

        var xAxis = d3.svg.axis().scale(x).orient('bottom').ticks(tickCount).tickFormat(function (d) {
            return chartUtils.format(d, displayFormat, currencyPrefix, maxValue, baseFormat, isDecimalPercentNumber);
        });

        var yAxis = d3.svg.axis().scale(y).orient('left').tickFormat(function (d) {
            if (yAxisFormat == "mmm" || smartLabels && yFieldName.toLowerCase().indexOf('month') >= 0) return chartUtils.toMonthName(d);

            return d;
        });

        function drawYAxisGrid() {
            return d3.svg.axis().scale(y).orient('left');
        }

        function drawXAxisGrid() {
            return d3.svg.axis().scale(x).orient('bottom');
        }

        var tempY = Number(chartY) + Number(chartHeight);

        chartContainer.append('g').attr('class', 'y axis').attr('transform', 'translate(' + chartX + ',' + chartY + ')').style('opacity', function () {
            if (hideYAxis) return 0;
            return 1;
        }).call(yAxis);

        if (gridLines == chartUtils.chartGridLine.both || gridLines == chartUtils.chartGridLine.yaxis) chartContainer.append('g').attr('class', 'y axis-grid').attr('transform', 'translate(' + chartX + ',' + chartY + ')').call(drawYAxisGrid().tickSize(-chartWidth, 0, 0).tickFormat(""));

        var yAxisLabelContainer = svg.append('g').append('text').attr('class', 'label y axis-label').attr('transform', 'rotate(-90)').attr('x', -1 * (chartHeight / 2 + Number(chartY))).attr('y', labelX).attr('dy', '0.5em').style('text-anchor', 'middle').text(yAxisText);

        if (!hideYAxis) {
            svg.selectAll('.tick').select('text').attr('transform', function (d) {
                return 'rotate(-' + rotationAngle + ')';
            }).attr('class', function (d) {
                return 'dataviz';
            }).attr('coord', function (d, i) {
                var crumb = crumbFormat;
                crumb.DefaultPerspective = defaultPerspective;
                crumb.Value = d;
                var crumbValue = chartUtils.findValue(baseYValues, crumb.FieldName, d);
                if (crumbValue != null) crumb.DisplayValue = crumbValue[crumb.DisplayFieldName];
                return JSON.stringify(crumb);
            });
        }

        var currentxAxisText = "";

        if (!xAxisText == null) currentxAxisText = xAxisText + ' Distribution'; //Appending X-axis text for normalized datas

        for (var _idx = 0; _idx < seriesConfigLength; _idx++) {
            if (!seriesConfig[_idx].ShowPercentage) {
                currentxAxisText = xAxisText;
                break;
            }
        }

        chartContainer.append('g').attr('class', 'x axis').attr('transform', 'translate(' + chartX + ',' + tempY + ')').style('opacity', function () {
            if (hideXAxis) return 0;
            return 1;
        }).call(xAxis);

        var xAxisLabelContainer = chartContainer.append('g').append('text').attr('class', 'label x axis-label').attr('x', Number(chartWidth) + Number(chartX)).attr('y', Number(xAxisLabelY) + Number(chartY)).style('text-anchor', 'end').text(currentxAxisText);

        if (gridLines == chartUtils.chartGridLine.both || gridLines == chartUtils.chartGridLine.xaxis) chartContainer.append('g').attr('transform', 'translate(' + chartX + ',' + tempY + ')').attr('class', 'x axis-grid').call(drawXAxisGrid().tickSize(-chartHeight, 0, 0).tickFormat(""));

        var group = chartContainer.selectAll('.group').data(baseYValues).enter().append('g').attr('transform', function (d) {
            return 'translate(0,' + y(d[yFieldName]) + ')';
        }).attr('class', 'group').attr('id', function (d, i) {
            return 'group' + i;
        });

        svg.selectAll('.tick text').attr('class', 'axis-text');

        svg.selectAll('.y text').attr('class', 'axis-text category-text dataviz');

        if (seriesConfig != null) {
            for (var index = 0; index < seriesConfig.length; index++) {
                var series = seriesConfig[index];

                if (series.SeriesType != chartUtils.chartSeriesType.bar) continue;

                var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');

                if (seriesAccumulators[seriesName] == null) continue;

                var accumulator = seriesAccumulators[seriesName];

                if (series.SeriesType != chartUtils.chartSeriesType.bar || accumulator.length == 0) continue;

                group.append('rect').attr('class', 'bar dataviz ' + chartUtils.makeStyleName(seriesName) + ' s' + chartUtils.makeStyleName(seriesName)).style('fill', function (d) {
                    var fillColor = seriesColor(seriesName);
                    if (series.Color != null && series.Color.trim().length > 0) fillColor = series.Color;

                    if (series.FormatConfig != null && series.FormatConfig.length > 0) {
                        var displaytext = d[series.FieldName];
                        var formatOption = getFormatOption(series, displaytext, d);
                        if (formatOption != null) {
                            fillColor = formatOption.Fill;
                            this.style.stroke = formatOption.BorderColor;
                            if (formatOption.Animate == true) {
                                this.attributes['class'].value = this.attributes['class'].value + ' animate';
                            }
                        }
                    }
                    return fillColor;
                }).attr('y', y1(series.SeriesName) + Number(chartY)).attr('label', function (d, i) {
                    var value = 0;
                    var displayFormat = series.ValueFormat;
                    var currencyPrefix = series.CurrencySymbol;
                    var baseFormat = series.BaseFormat;

                    var yValue = d[yFieldName];
                    var index = accumulator.map(function (e) {
                        return e[yFieldName];
                    }).indexOf(yValue);

                    if (index < 0) return;

                    if (accumulator[index] == null) return "--";

                    value = Number(accumulator[index][series.FieldName]);

                    if (isNaN(value)) value = 0;

                    var labelPrefix = accumulator[index][tipField] == null ? accumulator[index][yFieldName] : accumulator[index][tipField];

                    if (tipField == null || tipField.trim().length == 0) tipField = series.FieldName;

                    var name = series.SeriesName;;

                    if (name.trim() == '--') name = '';

                    if (series.ShowDefaultTooltip) {
                        var defaultTipText = '<span class="tip-header">' + name + ':</span><span class="tip-value"> ' + chartUtils.format(value, displayFormat, currencyPrefix, maxValue, baseFormat, isDecimalPercentNumber) + '</span>';
                    }

                    var tooltip = series.Tooltip;

                    var tempTooltipText = "";
                    var tempTooltip = null;
                    var percentVal = Math.round(value * 10 / 10) + "%<br/>";

                    if (tooltip != null) {
                        tempTooltipText = tooltip.TooltipText;
                        if (series.ShowPercentage) tooltip.TooltipText = tooltip.TooltipText.replaceAll('{' + series.FieldName + '}', percentVal);
                    } else if (series.ShowPercentage) {
                        tooltip = { TooltipConfigs: [], TooltipText: "" };
                        tooltip.TooltipText = series.seriesName + " % : " + percentVal;
                    }
                    var tipText = chartUtils.buildTooltipText(tooltip, accumulator[index], defaultTipText, series.FieldName, series.AggregationType, series.TotalRecords);
                    if (tooltip !== null) tooltip.TooltipText = tempTooltipText;else tooltip = tempTooltip;

                    return tipText;
                }).attr('value', function (d, i) {
                    var yValue = d[yFieldName];
                    var index = accumulator.map(function (e) {
                        return e[yFieldName];
                    }).indexOf(yValue);

                    if (index < 0) return 0;

                    if (accumulator[index] != undefined) return Number(accumulator[index][series.FieldName]).toFixed(2);else return 0;
                }).attr('x', function (d, i) {
                    var yValue = d[yFieldName];

                    var index = accumulator.map(function (e) {
                        return e[yFieldName];
                    }).indexOf(yValue);
                    if (index < 0) return x(0);

                    var value = Number(accumulator[index][series.FieldName]);
                    var base = Number(accumulator[index]['base']);

                    if (value <= 0) return x(value) + Number(chartX);

                    return x(base) + Number(chartX);
                }).attr('height', y1.rangeBand()).attr('seriesidentifier', series.SeriesName).attr('id', function (d, i) {
                    return 'Bar' + i;
                }).attr('coord', function (d, i) {
                    var yValue = d[yFieldName];
                    var index = accumulator.map(function (e) {
                        return e[yFieldName];
                    }).indexOf(yValue);

                    if (index < 0) return;

                    if (accumulator[index] != undefined) {
                        crumbFormat.Value = accumulator[index][series.CrumbFieldName];
                        crumbFormat.DisplayValue = accumulator[index][series.CrumbDisplayFieldName];
                    } else {
                        crumbFormat.Value = '';
                        crumbFormat.DisplayValue = '';
                    }

                    crumbFormat.FieldName = series.CrumbFieldName;
                    crumbFormat.DisplayFieldName = series.CrumbDisplayFieldName;
                    crumbFormat.DefaultPerspective = defaultPerspective;

                    return JSON.stringify(crumbFormat);
                }).attr('id', function (d, i) {
                    return seriesName + i;
                }).attr('width', 0).on("touchstart", function () {
                    columnTooltip.onMouseOver.call(this, parentContainerId);
                }).on("mouseover", function () {
                    columnTooltip.onMouseOver.call(this, parentContainerId);
                }).on("mouseout", columnTooltip.onMouseOut).on("touchmove", columnTooltip.onTouchMove).on("mousemove", function () {
                    columnTooltip.onMouseMove.call(this, parentContainerId);
                }).transition().duration(500).ease(transitionEase).attr('width', function (d, i) {
                    var yValue = d[yFieldName];
                    var index = accumulator.map(function (e) {
                        return e[yFieldName];
                    }).indexOf(yValue);

                    if (index < 0) return x(value);

                    var value = Number(accumulator[index][series.FieldName]);
                    var baseY = Number(accumulator[index]["base"]);

                    if (value < 0) return x(baseY) - x(value + baseY);
                    return x(value + baseY) - x(baseY);
                });

                truncateTextByPixel(ContainerId, true);

                svg.selectAll(".animate").append("animate").attr('attributeType', "XML").attr('attributeName', 'opacity').attr('from', '0.6').attr('to', '0.3').attr('dur', '1s').attr('repeatCount', 'indefinite');

                if (series.SubSeries != null && series.SubSeries.length > 0) {
                    var baseSeries = series;

                    for (var index1 = 0; index1 < baseSeries.SubSeries.length; index1++) {

                        series = baseSeries.SubSeries[index1];

                        if (series.SeriesType != chartUtils.chartSeriesType.bar) continue;

                        seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');

                        if (seriesAccumulators[seriesName] == null) continue;

                        var accumulator = seriesAccumulators[seriesName];

                        if (accumulator.length > 0) {
                            group.append('rect').attr('class', 'bar dataviz ' + chartUtils.makeStyleName(seriesName) + ' s' + chartUtils.makeStyleName(seriesName)).style('fill', series.Color == null ? seriesColor(seriesName) : series.Color).attr('y', y1(baseSeries.SeriesName) + Number(chartY)).attr('label', function (d, i) {
                                var value = 0;
                                var displayFormat = series.ValueFormat;
                                var currencyPrefix = series.CurrencySymbol;
                                var baseFormat = series.BaseFormat;

                                var yValue = d[yFieldName];
                                var index = accumulator.map(function (e) {
                                    return e[yFieldName];
                                }).indexOf(yValue);

                                if (index < 0) return;

                                if (accumulator[index] == null) return "--";

                                value = Number(accumulator[index][series.FieldName]);

                                if (isNaN(value)) value = 0;

                                var labelPrefix = accumulator[index][tipField] == null ? accumulator[index][yFieldName] : accumulator[i][tipField];

                                if (tipField == null || tipField.trim().length == 0) tipField = yFieldName;

                                var name = series.SeriesName;

                                if (name.trim() == '--') name = '';

                                if (series.ShowDefaultTooltip) {
                                    var defaultTipText = '<span class="tip-header">' + name + ':</span><span class="tip-value"> ' + chartUtils.format(value, displayFormat, currencyPrefix, maxValue, baseFormat, isDecimalPercentNumber) + '</span>';
                                }

                                var tooltip = series.Tooltip;
                                var tempTooltipText = "";
                                var tempTooltip = null;
                                var percentVal = Math.round(value * 10 / 10) + "%<br/>";

                                if (tooltip != null) {
                                    tempTooltipText = tooltip.TooltipText; //Appending percentages to the tooltips for normalized data
                                    if (series.ShowPercentage) tooltip.TooltipText = tooltip.TooltipText.replaceAll('{' + series.FieldName + '}', percentVal);
                                } else if (series.ShowPercentage) {
                                    tooltip = { TooltipConfigs: [], TooltipText: "" };
                                    tooltip.TooltipText = series.SeriesName + " % : " + percentVal;
                                }
                                var tipText = chartUtils.buildTooltipText(tooltip, accumulator[index], defaultTipText, series.FieldName, series.AggregationType, series.TotalRecords);
                                if (tooltip != null) tooltip.TooltipText = tempTooltipText;else tooltip = tempTooltip;

                                return tipText;
                            }).attr('value', function (d, i) {
                                var yValue = d[yFieldName];
                                var index = accumulator.map(function (e) {
                                    return e[yFieldName];
                                }).indexOf(yValue);

                                if (index < 0) return 0;

                                if (accumulator[index] != undefined) return Number(accumulator[index][series.FieldName]).toFixed(2);else return 0;
                            }).attr('x', function (d, i) {
                                var yValue = d[yFieldName];
                                var index = accumulator.map(function (e) {
                                    return e[yFieldName];
                                }).indexOf(yValue);

                                if (index < 0) return x(0);

                                var value = Number(accumulator[index][series.FieldName]);
                                var baseY = Number(accumulator[index][base]);
                                var negativeBaseY = Number(accumulator[index][negativeBase]);

                                if (value <= 0) return isNaN(x(negativeBaseY) + Number(chartX)) ? x(0) : x(negativeBaseY) + Number(chartX);
                                return x(baseY) + Number(chartX);
                            }).attr('height', function (d, i) {
                                return y1.rangeBand();
                            }).attr('coord', function (d, i) {
                                var yValue = d[yFieldName];
                                var index = accumulator.map(function (e) {
                                    return e[yFieldName];
                                }).indexOf(yValue);

                                if (index < 0) return;

                                if (accumulator[index] == null) return;

                                crumbFormat.Value = accumulator[index][series.CrumbFieldName];
                                crumbFormat.DisplayValue = accumulator[index][series.CrumbDisplayFieldName];

                                crumbFormat.FieldName = series.CrumbFieldName;
                                crumbFormat.DisplayFieldName = series.CrumbDisplayFieldName;
                                crumbFormat.DefaultPerspective = defaultPerspective;

                                return JSON.stringify(crumbFormat);
                            }).attr('seriesidentifier', series.SeriesName).attr('id', function (d, i) {
                                return seriesName + i;
                            }).attr('width', 0).on("touchstart", function () {
                                columnTooltip.onMouseOver.call(this, parentContainerId);
                            }).on("mouseover", function () {
                                columnTooltip.onMouseOver.call(this, parentContainerId);
                            }).on("mouseout", columnTooltip.onMouseOut).on("touchmove", columnTooltip.onTouchMove).on("mousemove", function () {
                                columnTooltip.onMouseMove.call(this, parentContainerId);
                            }).transition().duration(500).ease(transitionEase).attr('width', function (d, i) {
                                var yValue = d[yFieldName];
                                var index = accumulator.map(function (e) {
                                    return e[yFieldName];
                                }).indexOf(yValue);

                                if (index < 0) return 0;

                                var value = Number(accumulator[index][series.FieldName]);
                                var baseY = Number(accumulator[index]["base"]);
                                var negativeBaseY = Number(accumulator[index]["negative-base"]);
                                if (value < 0) return isNaN(x(negativeBaseY) - x(value + negativeBaseY)) ? x(0) : x(negativeBaseY) - x(value + negativeBaseY);
                                return isNaN(x(value + baseY) - x(baseY)) ? x(0) : x(value + baseY) - x(baseY);
                            });
                            truncateTextByPixel(ContainerId, true);
                        }
                    }
                }
            }
        }

        for (var index = 0; index < seriesConfig.length; index++) {
            var series = seriesConfig[index];

            if (series.ShowLabels) {

                if (series.SeriesType != chartUtils.chartSeriesType.bar) continue;

                var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');

                if (seriesAccumulators[seriesName] == null) continue;

                var accumulator = seriesAccumulators[seriesName];

                if (series.SubSeries != null) var data = displayCount > 0 ? chartUtils.getTop(displayCount, baseYValues) : baseYValues;else var data = displayCount > 0 ? chartUtils.getTop(displayCount, accumulator) : accumulator;

                var textAnchor = 'end';

                if (series.LabelPosition == chartUtils.labelPosition.outside) textAnchor = 'start';

                chartContainer.selectAll('.text').data(data).enter().append('text').attr('x', function (d) {
                    var textX = x(d[series.FieldName]);

                    if (d[base] != null) textX = x(series.SubSeries != null ? d[base] : d[series.FieldName]);

                    return textX + Number(chartX) + Number(textOffset);
                }).attr('y', function (d) {
                    return y(d[yFieldName]) + Number(y1(series.SeriesName)) + y1.rangeBand() / 2 + Number(chartY) + 2;
                }).attr('text-anchor', textAnchor).attr('fill', series.LabelPosition == chartUtils.labelPosition.outside || series.StackOnField != null ? '#000' : series.Color == null ? chartUtils.getLabelColor(seriesColor(seriesName)) : chartUtils.getLabelColor(series.Color)).text(function (d) {
                    var value = d[series.FieldName];

                    if (d[base] != null) value = series.SubSeries != null ? Number(d[base]) : Number(d[series.FieldName]);

                    return chartUtils.format(value, series.ValueFormat, series.CurrencySymbol, maxValue, series.BaseFormat, isDecimalPercentNumber);
                }).attr('class', 'column-label').attr('opacity', 0).transition().delay(500).duration(200).attr('opacity', 1);
            }
        }

        if (showLegend) {
            var legendItems = [];
            var legendItem = {};

            for (var i = 0; i < seriesConfig.length; i++) {
                var series = seriesConfig[i];

                var seriesName = chartUtils.replaceAll(series.SeriesName, ' ', '');

                legendItem = chartUtils.findValue(legendItems, 'SeriesName', seriesName);
                if (legendItem != null) continue;

                legendItem = {};
                legendItem['SeriesCode'] = seriesName;
                seriesName = "SeriesName";
                legendItem[seriesName] = series.SeriesName;

                if (series.StackOnField != null) seriesName = series.StackOnField;
                if (series.GroupOnField != null) seriesName = series.GroupOnField;

                legendItem[seriesName] = series.SeriesName;
                legendItem['SeriesNameValue'] = series.SeriesName;
                legendItem['color'] = series.Color;
                legendItems.push(legendItem);

                if (series.SubSeries != null) {
                    for (var index = 0; index < series.SubSeries.length; index++) {
                        legendItem = {};
                        seriesName = chartUtils.replaceAll(series.SubSeries[index].SeriesName, ' ', '');
                        legendItem['SeriesCode'] = seriesName;
                        seriesName = "SeriesName";
                        legendItem[seriesName] = series.SubSeries[index].SeriesName;

                        if (series.StackOnField != null) seriesName = series.StackOnField;
                        if (series.GroupOnField != null) seriesName = series.GroupOnField;

                        legendItem[seriesName] = series.SubSeries[index].SeriesName;
                        legendItem['SeriesNameValue'] = series.SubSeries[index].SeriesName;
                        legendItem['color'] = series.SubSeries[index].Color;
                        legendItems.push(legendItem);
                    }
                }
            }

            if (series.StackOnField != null || series.GroupOnField != null) {

                if (seriesName.toLocaleLowerCase().indexOf('month') >= 0) {
                    chartUtils.sort(legendItems, seriesName);
                } else if (seriesName.toLocaleLowerCase().indexOf('day') >= 0) {
                    chartUtils.sort(legendItems, seriesName);
                } else {
                    legendItems.sort(function (a, b) {
                        return a.SeriesNameValue > b.SeriesNameValue ? 1 : b.SeriesNameValue > a.SeriesNameValue ? -1 : 0;
                    });
                }
            }

            var legendCount = legendItems.length;
            var legendCountInOneLine = Math.ceil(legendCount / legendLineCount);
            var legendSectionWidth = (width - Number(chartX) - margin.right * width) / legendCountInOneLine;
            var currentLegendLine = 0;

            var legendHeight = Number(legendItems.length) * Number(legendRectSize) + Number(legendSpacing) + Number(offset);

            if (legendLocation == chartUtils.legendLocation.left || legendLocation == chartUtils.legendLocation.right) legendY = Number(chartHeight) / 2 - Number(legendHeight) / 2 + Number(chartY);

            var legendContainer = svg.append('g');
            legendContainer.attr('transform', 'translate(' + legendX + ',' + legendY + ')');

            //draw legend
            var legend = legendContainer.selectAll('.legend').data(legendItems).enter().append('g').attr('class', function (d) {
                return 'legend ' + d['SeriesCode'];
            }).attr('transform', function (d, i) {
                var itemHeight = Number(legendRectSize) + Number(legendSpacing);
                var horz = 0;
                var vert = i * (Number(itemHeight) + Number(offset));

                if (legendLocation == chartUtils.legendLocation.top || legendLocation == chartUtils.legendLocation.bottom) {
                    horz = i % legendCountInOneLine * Number(legendSectionWidth) + Number(legendSpacing);
                    vert = Math.floor(i / legendCountInOneLine) * (Number(legendRectSize) + Number(legendSpacing));
                }

                return "translate(" + horz + "," + vert + ")";
            });

            //draw legend colored rectangles
            legend.append('rect').attr('width', Number(legendRectSize)).attr('height', Number(legendRectSize)).attr('class', function (d) {
                return 'legend ' + d['SeriesCode'] + ' s' + d['SeriesCode'];
            }).style('fill', function (d) {
                return d.color == null ? seriesColor(d['SeriesCode']) : d.color;
            });

            //draw legend text
            legend.append('text').attr('x', Number(legendRectSize) + Number(legendSpacing)).attr('y', Number(legendRectSize) / 2).attr('dy', '.35em').attr('class', 'legend-text').style('text-anchor', 'start').text(function (d) {
                return d[seriesName];
            });
        }

        if (stampText != null && stampText.trim().length > 0) {
            var stampTextContainer = svg.append('g');

            var rectWidth = width / 1.5;
            var rectHeight = 80;

            stampTextContainer.append("foreignObject").attr("x", 0).attr("y", 0).attr("width", rectWidth).attr("height", rectHeight).append("xhtml:body").html("<p class='stampText'>" + stampText + "</p>");
        }

        function getFormatOption(series, value, d) {
            var conditionalFormats = series.FormatConfig;
            for (var cf = 0; cf < conditionalFormats.length; cf++) {
                var conditionalFormat = conditionalFormats[cf];
                var displayText = value == "" || value == null ? NaN : value;
                if (conditionalFormat.TableField != "--" && conditionalFormat.TableField != null) displayText = d[conditionalFormat.TableField] == null ? NaN : d[conditionalFormat.TableField];

                if (conditionalFormat.TargetProperty != null && conditionalFormat.TargetProperty != "--") {
                    if (d[conditionalFormat.TargetProperty] != null) conditionalFormat.FormatValue = d[conditionalFormat.TargetProperty];
                }
                var expression = chartUtils.buildFormatExpression(conditionalFormat, displayText);
                try {
                    if (eval(expression)) {
                        if (conditionalFormat.FormatOption != null) {
                            return conditionalFormat.FormatOption[0];
                        }
                    }
                } catch (ex) {
                    //Ignore exception & continue to next cell.
                }
            }
        }

        function sort(accumulator) {
            if (sortData != null && sortKeyName != null && sortValueName == null) {
                var temp = [];

                for (var i = 0; i < accumulator.length; i++) {
                    temp.push(accumulator[i]);
                }accumulator.length = 0;

                for (var index = sortData.length - 1; index >= 0; index--) {
                    var sortKey = sortData[index][sortKeyName];

                    var value = chartUtils.findValue(temp, yFieldName, sortKey);

                    if (value == null) continue;

                    accumulator.push(value);
                }

                return;
            }

            if (!sortAxis) sortAxis = chartUtils.isSpecialSort(yFieldName);

            if (sortAxis) chartUtils.sort(accumulator, yFieldName, null, inverseSort);else {
                inverseSort = !inverseSort;
                chartUtils.sort(accumulator, base, null, inverseSort, null, true);
            }
        };
    };

    // Initiate rendering for a widget
    var initiateWidgetRendering = function initiateWidgetRendering(configObj) {
        // Get widget specific widgetConfig
        var widgetConfig = barChartConfigBuilder.configBuilder(cloneDeep(configObj));
        renderWidget(widgetConfig);
    };

    return {
        initiateWidgetRendering: initiateWidgetRendering
    };
};

export default barChart();